import { Children } from "react";

import * as S from "./styles";
import { Text } from "@aprosoja/ui";

type TabsProps = {
  value: string;
  onChange: (value: string) => void;
  tabs: { value: string; title: string }[];
};

const Tabs = ({ value, onChange, tabs }: TabsProps) => {
  return (
    <div className="flex w-full">
      {Children.toArray(
        tabs.map((tab) => (
          <div
            className={S.tab({ isFocused: value === tab.value })}
            onClick={() => value !== tab.value && onChange(tab.value)}
          >
            <Text type="headingS" color="th-primary-color-main">
              {tab.title}
            </Text>
          </div>
        ))
      )}
    </div>
  );
};

export default Tabs;
